export default "__VITE_ASSET__04fda06c__"